import { render, staticRenderFns } from "./VMenuPat.vue?vue&type=template&id=5fb43a46"
import script from "./VMenuPat.vue?vue&type=script&lang=js"
export * from "./VMenuPat.vue?vue&type=script&lang=js"
import style0 from "./VMenuPat.vue?vue&type=style&index=0&id=5fb43a46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports